export default "__VITE_ASSET__be660762__"